export interface Iauth {
  email: string;
  password: string;
}

export enum Output {
  PDF = "pdf",
  HTML = "html",
  CSV = "csv",
  XLS = "xls",
}

export namespace Output {
  export const isPDF = (output: Output) => output === Output.PDF;
  export const isHTML = (output: Output) => output === Output.HTML;
  export const isCSV = (output: Output) => output === Output.CSV;
  export const isXLS = (output: Output) => output === Output.XLS;
}
